// extracted by mini-css-extract-plugin
export default {"containerGlobal":"ControllerViewClient_containerGlobal__3HcuU","containerData":"ControllerViewClient_containerData__jSwaj"};